import { render, staticRenderFns } from "./SsTextarea.vue?vue&type=template&id=37933a5d&scoped=true&"
import script from "./SsTextarea.vue?vue&type=script&lang=js&"
export * from "./SsTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37933a5d",
  null
  
)

export default component.exports